/** @jsx jsx */
import { jsx } from '@emotion/react';
import ContentTreeNode from './contentTreeNode';
import { Fragment } from 'react';
import GettingStarted from '../../../static/icons/GettingStarted';
import Cli from '../../../static/icons/Cli';
import Config from '../../../static/icons/Config';
import Guide from '../../../static/icons/Guide';
import Resource from '../../../static/icons/Resource';
import Sdk from '../../../static/icons/Sdk';
import { colors } from '../../theme';

// children.forEach((child) => {
//   const expandedByUser = globalStore.expandedStateByUserAction[child.url];
//   const expandedByPath = child.children.some((grandChild) => {
//     return [grandChild.url, `${grandChild.url}/`].includes(location.pathname);
//   });
//   globalStore.toggleExpanded(location.pathname);
//   const expanded = expandedByUser === undefined ? expandedByPath : expandedByUser;
// });

// const toggle = (url) => {
//   globalStore.toggleExpanded(url);
// };

const icons = { GettingStarted, Cli, Config, Guide, Resource, Sdk };

const ContentTreeGroup = ({ title, icon, location, children, expandedNavItems, setExpandedNavItems }) => {
  const SvgIcon = icons[icon];

  return (
    <div
      css={{
        display: 'block',
        padding: '0',
        position: 'relative',
        marginBottom: '12px',
        span: {
          padding: '5px 16px',
          fontSize: '13px',
          fontFamily: 'Content-font, Roboto, sans-serif',
          fontWeight: 700,
          lineHeight: 1,
          letterSpacing: '1.2px',
          textTransform: 'uppercase',
          position: 'relative',
          color: colors.lightGray
        },
        '> span': {
          marginBottom: '5px',
          display: 'flex',
          alignItems: 'center',
          img: {
            width: '18px',
            marginRight: '7px'
          }
        }
      }}
    >
      {title ? (
        <Fragment>
          <span>
            <SvgIcon style={{ marginRight: '10px' }} />
            &nbsp; {title}
          </span>
        </Fragment>
      ) : null}
      <ul>
        {children.map((child) => (
          <ContentTreeNode
            expandedNavItems={expandedNavItems}
            setExpandedNavItems={setExpandedNavItems}
            key={child.url}
            location={location}
            {...child}
          />
        ))}
      </ul>
    </div>
  );
};

export default ContentTreeGroup;
